import { Component, OnInit, Input, DoCheck, Optional, Output, EventEmitter } from '@angular/core';
import { FormControl, Validators, FormGroup, AbstractControl, ControlContainer, FormGroupDirective } from '@angular/forms';
import { ErrorMassageValidation } from '../../Shared/services/validationErrorMassage.service';
import { UtilityService } from '../../Shared/services/UtilityService';
import { ControlUtility } from '../../Shared/services/ControlUtility';
import { CheckBoxOptions } from '../../Shared/Models/CheckBoxOptions';
import { RadioButtonOptions } from '../../Shared/Models/RadioButtonOptions';

@Component({
  // tslint:disable-next-line: component-selector
  selector: 'BBSF-RadioButton',
  templateUrl: './RadioButton.component.html',
  styleUrls: ['./RadioButton.component.scss']
})
export class RadioButtonComponent implements OnInit {


  static controlContainerstatic = null;
  // tslint:disable-next-line: max-line-length
  constructor(private controlUtility: ControlUtility, @Optional() private controlContainer: ControlContainer, public RadioButtonControlHost: FormGroupDirective) {
    RadioButtonComponent.controlContainerstatic = this.controlContainer;
  }
  @Input() group: FormGroup;
  @Input() options: RadioButtonOptions;
  @Output() OnChange = new EventEmitter();

  RadioButtonFormControl: AbstractControl;
  markAllAsTouched: boolean = false;
  validationRules = [];
  validationRulesasync = [];
  ngOnInit() {

    this.group.addControl(this.options.Name, new FormControl(''));
    this.RadioButtonFormControl = this.group.controls[this.options.Name]; //  new FormControl('',validationRules);


    if (this.options.IsRequired) {
      this.validationRules.push(Validators.required);
    }
    this.RadioButtonFormControl.setValidators(this.validationRules);
    this.RadioButtonFormControl.setAsyncValidators(this.validationRulesasync);
    if (this.options.IsDisabled) {
      this.RadioButtonFormControl.disable();
    }

    if (this.options.LabelKey != null && this.options.LabelKey != "")
      this.options.LabelValue = UtilityService.getResourceValue(this.options.LabelKey);


    this.RadioButtonControlHost.ngSubmit.subscribe((value) => {
      this.group.markAllAsTouched()
      this.markAllAsTouched = true
    })

    if (this.options.Value) {
      this.RadioButtonFormControl.setValue(this.options.Value.Value);
    }

  }

  resetError = () => {
    UtilityService.RemoveGlobalError();
  }

  showGlobalError() {
    this.controlUtility.showGlobalError()
  }

  getErrorValidation(ErrorList) {
    if (this.markAllAsTouched && this.group.invalid) {
      this.showGlobalError()
      this.markAllAsTouched = false
    }

    return this.controlUtility.getErrorValidationMassage(ErrorList, this.group, this.options);
  }

  onValueChanged() {
    this.OnChange.emit(this.RadioButtonFormControl.value)
  }


  //External Method
  RemoveRequiredValidation = () => {
    this.controlUtility.RemoveRequiredValidation(this.RadioButtonFormControl, this.validationRules, this.options)
  }
  //External Method
  AddRequiredValidation = () => {
    this.controlUtility.AddRequiredValidation(this.RadioButtonFormControl, this.validationRules, this.options)
  }

  //External Method
  RemoveCustomValidation = (CustomValidation) => {
    this.controlUtility.RemoveCustomValidation(this.RadioButtonFormControl, this.validationRules, CustomValidation)
  }
  //External Method
  AddCustomValidation = (CustomValidation) => {
    this.controlUtility.AddCustomValidation(this.RadioButtonFormControl, this.validationRules, CustomValidation)
  }
  //External Method
  IsValid = () => {
    this.controlUtility.IsValid(this.RadioButtonFormControl)
  }
}


